import React, { useState, useEffect } from "react";
import { MetaTags } from "react-meta-tags";
import HeaderLogoBar from "../../pages/HeaderLogoBar";
import AlertNoInternet from "../AlertNoInternet";
import styles from "./TestWizard.module.css";
import "../../styles/bizofficer.css";
import { WHITE_LABEL_LOGO_URL } from "../../utils/EnvVars";
import "font-awesome/css/font-awesome.min.css";
import ModeStandbyIcon from "@mui/icons-material/ModeStandby";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";

export default function TestWizard() {
  const internetRef = React.useRef();
  const [currentChunk, setCurrentChunk] = useState(0);
  const [chunks, setChunks] = useState([]);

  // Get URL parameters
  const authResult = new URLSearchParams(window.location.search);
  const courseUrl = authResult.get("courseUrl");
  const courseId = authResult.get("courseId");
  const utmSource = authResult.get("utm_source");
  const deviceType = authResult.get("device_type");
  const testUid = authResult.get("testUid");
  let testType = authResult.get("testType");
  const assessmentMode = authResult.get("assessmentMode");
  const searchFlag = authResult.get("searchFlag");
  const searchQuery = authResult.get("searchQuery");
  const topicId = authResult.get("topicId");

  console.log(testType);

  if (!testType) testType = 0;
  if (deviceType && deviceType.length > 0) {
    localStorage.setItem("deviceType", deviceType);
  }

  useEffect(() => {
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    document.addEventListener("keydown", function (event) {
      if (
        event.ctrlKey ||
        event.keyCode === 123 ||
        (event.ctrlKey && event.shiftKey && event.keyCode === 73)
      ) {
        event.preventDefault();
      }
    });
  }, []);

  useEffect(() => {
    const contentChunks = [];

    if (testType == 1 && assessmentMode == "beginner") {
      contentChunks.push({
        title: "Gap Fixer - Smart Learning",
        content: (
          <div className={styles.welcomeContent}>
            <h2>Hey there! 👋</h2>
            <p>
              Welcome to Smart Learning – Practice Mode — your personal
              playground to learn by doing.
            </p>
            <div className={styles.goalSection}>
              <h3>🧠 What's the goal?</h3>
              <p>
                Not to score high — but to spot knowledge gaps and fix them
                through real practice.
              </p>
            </div>
          </div>
        ),
      });
    } else if (testType == 1 && assessmentMode == "advance") {
      contentChunks.push({
        title: "Smart Learning - Competitive Mode",
        content: (
          <div className={styles.welcomeContent}>
            {/* <h2>Welcome to Smart Learning - Competitive Mode 💪</h2> */}
            <p>Time to shift gears from learning to performing!</p>
            <div className={styles.goalSection}>
              <h3>🎯 What's the goal?</h3>
              <p>
                Now that you've practiced and filled your knowledge gaps, this
                mode helps you:
              </p>
              <ul>
                <li>Improve speed</li>
                <li>Boost accuracy</li>
                <li>Strengthen focus under time pressure</li>
              </ul>
            </div>
          </div>
        ),
      });
    } else {
      contentChunks.push({
        // title: "Welcome to ETL 👋",
        content: (
          <div className={styles.mockTestWelcomeContent} style={{display: "flex"}}>
            <div
              style={{
                width: "90%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <div className={styles.headerSection} style={{display: "flex"}}>
                <div className={styles.headingSection} style={{display: "flex", alignItems: "center",justifyContent: "center", gap: "10px"}}>
                  <ModeStandbyIcon className={styles.standbyIcon} />
                  <h2>Welcome to Your Mock Test</h2>
                </div>
                <p>
                  This is your chance to check how well-prepared you are for the
                  exam.
                </p>
              </div>
              <div className={styles.goalSectionParent} style={{display: "flex"}}>
                <div className={styles.goalGreen} style={{display: "flex"}}>
                  <div className={styles.headingSection} style={{display: "flex"}}>
                    <DoneAllIcon className={styles.progressGreen} />
                    <h3>If your progress bar turns green</h3>
                  </div>
                  <p>
                    That's excellent! It means you are ready to face the exam
                    with confidence.
                  </p>
                </div>
                <div className={styles.goalRed} style={{display: "flex"}}>
                  <div className={styles.headingSection} style={{display: "flex"}}>
                    <WarningAmberIcon className={styles.progressRed} />
                    <h3>If your progress bar is not green</h3>
                  </div>
                  <p>
                    Don't worry – it simply shows there are still some gaps. In
                    that case:
                  </p>
                  <ul>
                    <li>Go back to the Gap Fixer in our platform</li>
                    <li>Work through each topic until you turn it green</li>
                    <li>
                      With the help of Tony, your AI guide, you can strengthen
                      weak areas one by one
                    </li>
                  </ul>
                </div>
              </div>
              <div className={styles.finalSection} style={{display: "flex"}}>
                <div className={styles.finalSteps}>
                  <div className={styles.headingSection} style={{display: "flex"}}>
                    <SignalCellularAltIcon className={styles.stepsIcon} />
                    <h3>Steps to Follow Before the Final Exam</h3>
                  </div>
                  <div className={styles.finalStepsList} style={{display: "flex"}}>
                    <div className={styles.list}>
                      <span className={styles.listStyle}>1</span> Make sure each
                      Topic Assessment in&nbsp;<b>Learning mode</b>&nbsp;shows
                      green.
                    </div>
                    <div className={styles.list}>
                      <span className={styles.listStyle}>2</span> Ensure you are
                      green in the &nbsp;<b>Competitive Mode</b>&nbsp;as well.
                    </div>
                    <div className={styles.list}>
                      <span className={styles.listStyle}>3</span> Attempt the
                      &nbsp;<b>Mock Test</b>&nbsp;again after fixing gaps.
                    </div>
                  </div>
                </div>
                <div className={styles.finalPromise} style={{display: "flex"}}>
                  <div className={styles.headingSection} style={{display: "flex"}}>
                    <BookmarkAddedIcon className={styles.promiseIcon} />
                    <h3>Final Promise</h3>
                  </div>
                  <p>
                    If your progress bar is green in all topics in –{" "}
                    <strong>
                      Learning Mode, Competitive Mode, and Mock Test{" "}
                    </strong>
                    – you will be fully prepared and highly likely to clear the
                    exam.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ),
      });
    }

    if (testType == 1 && assessmentMode == "beginner") {
      contentChunks.push({
        title: "How to Use Practice Mode",
        content: (
          <div className={styles.instructionContent}>
            <div className={styles.section}>
              <h3>📌 How to Use This Session:</h3>
              <p>✅ Attempt each question sincerely.</p>
              <p>
                🛑 Don't worry if you're stuck or make mistakes — That's where
                the real learning begins.
              </p>
            </div>
            <div className={styles.section}>
              <h3>🤖 Tony AI has your back!</h3>
              <p>Ask Tony for:</p>
              <ul>
                <li>Hints & concepts</li>
                <li>Step-by-step explanations</li>
                <li>Tips to approach similar problems</li>
              </ul>
              <p>He's here to support your learning journey.</p>
            </div>
            <div className={styles.section}>
              <h3>⏱ No Timer, No Rush</h3>
              <p>
                Take it slow. Think deeply. Smart Learning – Practice Mode is
                your safe space to build strong concepts.
              </p>
              <p>
                Repeat till progress bar turns green. Then you can move on
                to next topic.
              </p>
            </div>
            <div className={styles.section}>
              <h3>📖 Use your:</h3>
              <ul>
                <li>Books & Notes</li>
                <li>Teachers</li>
                <li>Internet</li>
                <li>Tony AI (your learning assistant!)</li>
              </ul>
            </div>
          </div>
        ),
      });
    } else if (testType == 1 && assessmentMode == "advance") {
      contentChunks.push({
        title: "Competitive Mode Details",
        content: (
          <div className={styles.instructionContent}>
            <div className={styles.section}>
              <h3>⏱ What's different here?</h3>
              <p>This session is timed — like a race against the clock.</p>
              <p>No hints, no AI help. You're on your own now.</p>
            </div>
            <div className={styles.section}>
              <h3>Not an exam simulation!</h3>
              <p>
                Questions here vary in difficulty to test how deep and complete
                your topic knowledge really is.
              </p>
            </div>
            <div className={styles.section}>
              <h3>🧠 Why this matters:</h3>
              <p>
                Think of this as mental training. You're not just answering —
                you're learning to think fast, stay sharp, and stay accurate.
              </p>
            </div>
            <div className={styles.section}>
              <h3>🔁 Practice Mode → Competitive Mode → Exam Room</h3>
              <p>
                Mastery starts with understanding. This mode pushes you to apply
                it — fast and fearlessly.
              </p>
            </div>
          </div>
        ),
      });
    } else {
      contentChunks.push({
        title: "How to Navigate Your Test",
        content: (
          <div className={styles.instructionContent}>
            <div className={styles.section}>
              <h3>⏱ Time Management</h3>
              <p>
                The clock has been set at server and count down timer at the top
                right corner of the screen will display left out time to closure
                from where you can monitor time you have to complete the exam.
              </p>
            </div>

            <div className={styles.section}>
              <h3>📝 Answering Questions</h3>
              <ol>
                <li>Click answer option buttons to select your answer.</li>
                <li>
                  To change an answer, simply click the desired option button.
                </li>
                <li>Click on RESET button to deselect a chosen answer.</li>
                <li>
                  Click on SAVE & NEXT to save the answer before moving to the
                  next question. The next question will automatically be
                  displayed.
                </li>
                <li>
                  Click on SKIP to move to the next question without saving the
                  current question.
                </li>
                <li>
                  Click on MARK FOR REVIEW to review your answer at later stage.
                </li>
                <li>
                  Make sure you click on SAVE & NEXT button everytime you want
                  to save your answer.
                </li>
              </ol>
            </div>

            <div className={styles.section}>
              <h3>🧭 Navigation & Review</h3>
              <p>
                To go to a question, click on the question number on the right
                side of the screen.
              </p>
              <p>
                Candidate will be allowed to Shuffle between sections and
                questions anytime during the examination as per their
                convenience.
              </p>
              <p>
                Candidate can change their response of attempted answers anytime
                during the examination slot time by clicking another answer
                which candidates wants to change.
              </p>
            </div>

            <div className={styles.section}>
              <h3>📊 Question Status Indicators</h3>
              <p>
                The color coded diagram on the right side of the screen shows
                the status of the questions:
              </p>
              <div className={styles.questionStatus}>
                <div>
                  <div
                    className={styles.statusIcon}
                    style={{ background: "url('/not-visited.png')" }}
                  >
                    2
                  </div>{" "}
                  you have not visited question no 2.
                </div>
                <div>
                  <div
                    className={styles.statusIcon}
                    style={{ background: "url('/not-answered.png')" }}
                  >
                    3
                  </div>{" "}
                  you have not answered question no 3.
                </div>
                <div>
                  <div
                    className={styles.statusIcon}
                    style={{ background: "url('/answered.png')" }}
                  >
                    4
                  </div>{" "}
                  you have answered question no 4.
                </div>
                <div>
                  <div
                    className={styles.statusIcon}
                    style={{ background: "url('/review.png')" }}
                  >
                    5
                  </div>{" "}
                  you have marked the question no. 5 for review.
                </div>
                <div>
                  <div
                    className={styles.statusIcon}
                    style={{ background: "url('/answered-review.png')" }}
                  >
                    6
                  </div>{" "}
                  you have answered & marked for review of question no. 6
                </div>
              </div>
            </div>

            <div className={styles.section}>
              <h3>📈 Scoring</h3>
              <p>
                All the answered questions(saved or marked) will be considered
                for calculating the final score.
              </p>
            </div>

            <div className={styles.section}>
              <h3>⚠️ Important Warnings</h3>
              <div className={styles.warning}>
                Do Not PRESS any keyboard key once the exam is started. This
                will LOCK your exam. You can connect with the exam invigilator
                to unlock and continue giving the exam.
              </div>
              <div className={styles.warning}>
                Do Not CLICK on the SUBMIT Button unless you have completed the
                exam. In case you click SUBMIT button, you will not be permitted
                to continue.
              </div>
            </div>
          </div>
        ),
      });
    }

    contentChunks.push({
      title: "Ready to Start?",
      content: (
        <div className={styles.confirmationContent}>
          <h3>🚀 Ready to begin?</h3>
          {testType == 1 && assessmentMode == "beginner" && (
            <p>
              Tap Start Practice and let Smart Learning guide you to mastery!
            </p>
          )}
          {testType == 1 && assessmentMode == "advance" && (
            <p>Tap Start Competitive Mode and prove what you've learned!</p>
          )}
          {(!testType || testType == 0) && (
            <p>Click Start Test when you're ready to begin your examination.</p>
          )}
          <div className={styles.finalNote}>
            <p>
              Make sure you've read all instructions carefully before
              proceeding.
            </p>
          </div>
        </div>
      ),
    });

    setChunks(contentChunks);
  }, [testType, assessmentMode]);

  const handleNext = () => {
    if (currentChunk < chunks.length - 1) {
      setCurrentChunk(currentChunk + 1);
    }
  };

  const handleBack = () => {
    if (currentChunk > 0) {
      setCurrentChunk(currentChunk - 1);
    }
  };

  const startTest = () => {
    let qryStr = "";
    if (courseUrl && courseUrl.length > 0) qryStr += "&courseUrl=" + courseUrl;
    if (courseId && courseId > 0) qryStr += "&courseId=" + courseId;
    if (utmSource && utmSource.length > 0) qryStr += "&utm_source=" + utmSource;
    if (testUid && testUid.length > 0) qryStr += "&testUid=" + testUid;
    if (assessmentMode && assessmentMode.length > 0)
      qryStr += "&assessmentMode=" + assessmentMode;
    if (searchFlag && searchFlag.length > 0)
      qryStr += "&searchFlag=" + searchFlag;
    if (searchQuery && searchQuery.length > 0)
      qryStr += "&searchQuery=" + searchQuery;
    if (topicId && topicId > 0) qryStr += "&topicId=" + topicId;

    let testTypez = testType;
    if (!testTypez) testTypez = 0;

    window.location.href = "guest-testsimulator?testType=" + testTypez + qryStr;
  };

  if (chunks.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <MetaTags>
        <title>Guest Test Begin</title>
        <meta name="description" content="Guest Test Begin" />
      </MetaTags>

      {!window.navigator.onLine && (
        <div className="netBar">
          Alert: It seems, you are not connected to the internet.
        </div>
      )}

      {/* <HeaderLogoBar /> */}

      <div className={styles.wizardContainer}>
        <span class={styles.testWizardLogo}>
          {window.location.hostname === "localhost" ||
          window.location.hostname === "uat.easetolearn.com" ||
          window.location.hostname === "easetolearn.com" ? (
            <img
              src={process.env.PUBLIC_URL + "/ease_to_learn_logo.png"}
              style={{ height: 42 }}
            />
          ) : (
            <img
              src={
                WHITE_LABEL_LOGO_URL +
                "/" +
                window.location.hostname.replace(/\./g, "-") +
                ".png"
              }
              style={{ height: 37, marginRight: 35 }}
            />
          )}
        </span>

        {currentChunk > 0 && (
          <button className={styles.backButton} onClick={handleBack}>
            <i className="fa fa-arrow-left"></i>
          </button>
        )}

        <div className={styles.contentArea}>
          <div className={styles.stepContent}>
            <h1 className={styles.stepTitle}>{chunks[currentChunk].title}</h1>
            <div className={styles.stepBody}>
              {chunks[currentChunk].content}
            </div>
          </div>
        </div>

        <div className={styles.fixedNavigation}>
          <div className={styles.navigation}>
            {currentChunk < chunks.length - 1 ? (
              <button className={styles.nextButton} onClick={handleNext}>
                Next <i className="fa fa-arrow-right"></i>
              </button>
            ) : (
              <button className={styles.startButton} onClick={startTest}>
                {Number(testType) === 1 ? "Start Session" : "Start Test"}
              </button>
            )}
          </div>

          <div className={styles.progressDots}>
            {chunks.map((_, index) => (
              <div
                key={index}
                className={`${styles.dot} ${
                  index === currentChunk ? styles.active : ""
                } ${index < currentChunk ? styles.completed : ""}`}
              />
            ))}
          </div>
        </div>
      </div>

      <AlertNoInternet ref={internetRef} />
    </div>
  );
}
